import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./ViewFixedAsset.module.css";
// import plus from "../../../../Assets/plus.svg"
import { FaEdit, FaPen } from 'react-icons/fa';
// import DeleteIcon from "../../../../Assets/new-delete.svg"
import { Spinner, Badge, Button, Modal, Form, Alert, Table } from 'react-bootstrap';
import HeaderNav from "../../Accoungting/HeaderNav/FixedAssetNav";
import axios from "axios";
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
// "../../../../Components/Styles/API/API";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { Pencil } from "lucide-react";
import { FileSpreadsheet, FileText } from "lucide-react";
// import ToggleSlider from "./ToggleSlider";
import jsPDF from "jspdf";
import * as XLSX from 'xlsx';
import autoTable from "jspdf-autotable";

const ViewFixedAsset = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const { parishID } = location.state || {};
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [permId, setPermId] = useState([]);
  const [roleID, setRoleID] = useState([]);
  const [permLoading, setPermLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [toggleStates, setToggleStates] = useState({});
  const [roleStates, setRoleStates] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [roleCheckAll, setRoleCheckAll] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
 
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [userType, setUserType] = useState([]);
  const [zones, setZones] = useState([]);

  // Main filter states
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);

  // React Select states for filters
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  // React Select states for modal
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [selectedRegionModal, setSelectedRegionModal] = useState(null);
  const [selectedProvinceModal, setSelectedProvinceModal] = useState(null);
  const [regionsModal, setRegionsModal] = useState([]);
  const [provincesModal, setProvincesModal] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [totalEntries, setTotalEntries] = useState("");
  // const [totalPages, setTotalPages] = useState(1);
  const [areaLoad, setAreaLoad] = useState(false);
  const [areas, setAreas] = useState([]);

  const [responseData, setResponseData] = useState([]);
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [continentName, setContinentName] = useState(null);
  const [continentID, setContinentID] = useState(null);
  const [regionID, setRegionID] = useState(null);
  const [regionName, setRegionName] = useState(null);
  const [provinceID, setProvinceID] = useState(null);
  const [provinceName, setProvinceName] = useState(null);
  const [processLoading, setProcessLoading] = useState(false);
  const [processLoading1, setProcessLoading1] = useState(false);
  const [fetchMode, setFetchMode] = useState('default'); // 'default' or 'area'
  const [eyeClicked, setEyeClicked] = useState(false);
  const [isExcelLoading, setIsExcelLoading] = useState(false);
const [isPdfLoading, setIsPdfLoading] = useState(false);

  const [newUser, setNewUser] = useState({
    fullName: "",
    email: "",
    username: "",
    role: "",
    password: "",
    confirmPassword: ""
  });

  // Print View handler
  const handlePrintView = () => {
    navigate('/budget/charts_of_account/User');
  };

  // Pagination handlers
  const handleFirstPage = () => {
    if (currentPage > 1) {
      fetchUsers(1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      fetchUsers(totalPages);
    }
  };

  const handlePageClick = (page) => {
    if (page !== currentPage) {
      fetchUsers(page);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, currentPage + 2);

      if (currentPage <= 3) {
        endPage = maxVisiblePages;
      }
      if (currentPage >= totalPages - 2) {
        startPage = totalPages - maxVisiblePages + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value4 = await localStorage.getItem('provinceID');
      const value5 = await localStorage.getItem('regionID');
      const value6 = await localStorage.getItem('continentID');
      const conName = await localStorage.getItem('continent');
      const proName = await localStorage.getItem('province');
      const regName = await localStorage.getItem('region');

      if (value !== null) {
        setBearer(value);
      }
      if (value4 !== null) {
        setProvinceID(value4);
      }
      if (value5 !== null) {
        setRegionID(value5);
      }
      if (value6 !== null) {
        setContinentID(value6);
      }
      if (conName !== null) {
        setContinentName(conName);
      }
      if (proName !== null) {
        setProvinceName(proName);
      }
      if (regName !== null) {
        setRegionName(regName);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

 

  const searchUsers = async (searchQuery, page = 1) => {
    if (!bearer) {
      return;
    }

    setSearchLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await axios.get(`${BASE_URL}/users/search`, {
        headers,
        params: {
          variable: searchQuery,
          page: page
        }
      });

      console.log('Search API Response:', response);

      let usersData = [];
      let total = 0;
      let lastPage = 1;
      let currentPage = page;

      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data)) {
          usersData = response.data.data;
          total = usersData.length;
        }
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          usersData = response.data.data.data;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else if (response.data.data.users && Array.isArray(response.data.data.users)) {
          usersData = response.data.data.users;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else {
          const dataObj = response.data.data;
          const arrayKeys = Object.keys(dataObj).filter(key => Array.isArray(dataObj[key]));
          if (arrayKeys.length > 0) {
            usersData = dataObj[arrayKeys[0]];
            total = dataObj.total || usersData.length;
            lastPage = dataObj.last_page || 1;
            currentPage = dataObj.current_page || page;
          } else {
            usersData = [dataObj];
            total = 1;
          }
        }
      } else if (Array.isArray(response.data)) {
        usersData = response.data;
        total = usersData.length;
      }

      setUsers(usersData);
      setTotalUsers(total);
      setTotalPages(lastPage);
      setCurrentPage(currentPage);

    } catch (error) {
      console.error("Error searching users:", error);
      setUsers([]);
      setTotalPages(1);
      setCurrentPage(1);
      setTotalUsers(0);
    } finally {
      setSearchLoading(false);
      setLoading(false);
    }
  };

  const fetchUsers = async (page = 1) => {
    if (searchTerm.trim()) {
      await searchUsers(searchTerm, page);
      return;
    }

    try {
      setLoading(true);
      setError("");
      setSuccess("");

      if (!bearer) {
        setLoading(false);
        return;
      }

      let url = `${BASE_URL}/users/fetch-all`;
      let params = {
        page
      };

      const hasContinent = selectedContinent && selectedContinent.value !== 'all';
      const hasRegion = selectedRegion && selectedRegion.value !== 'all';
      const hasProvince = selectedProvince && selectedProvince.value !== 'all';

      if (hasContinent || hasRegion || hasProvince) {
        url = `${BASE_URL}/users/get-by-filter`;
        const filterParams = { page };
        if (hasContinent) filterParams.continent_id = selectedContinent.value;
        if (hasRegion) filterParams.region_id = selectedRegion.value;
        if (hasProvince) filterParams.province_id = selectedProvince.value;
        params = filterParams;
      }

      const response = await axios.get(url, {
        headers,
        params
      });

      console.log('Users API Full Response:', response);

      let usersData = [];
      let total = 0;
      let lastPage = 1;
      let currentPage = page;

      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data)) {
          usersData = response.data.data;
          total = usersData.length;
        }
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          usersData = response.data.data.data;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else if (response.data.data.users && Array.isArray(response.data.data.users)) {
          usersData = response.data.data.users;
          total = response.data.data.total || usersData.length;
          lastPage = response.data.data.last_page || 1;
          currentPage = response.data.data.current_page || page;
        }
        else {
          const dataObj = response.data.data;
          const arrayKeys = Object.keys(dataObj).filter(key => Array.isArray(dataObj[key]));
          if (arrayKeys.length > 0) {
            usersData = dataObj[arrayKeys[0]];
            total = dataObj.total || usersData.length;
            lastPage = dataObj.last_page || 1;
            currentPage = dataObj.current_page || page;
          } else {
            usersData = [dataObj];
            total = 1;
          }
        }
      } else if (Array.isArray(response.data)) {
        usersData = response.data;
        total = usersData.length;
      }

      setUsers(usersData);
      setTotalUsers(total);
      setTotalPages(lastPage);
      setCurrentPage(currentPage);

    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
      setTotalPages(1);
      setCurrentPage(1);
      setTotalUsers(0);
    } finally {
      setLoading(false);
    }
  };

  // Handle search input change with debounce
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm.trim()) {
        setCurrentPage(1);
        searchUsers(searchTerm, 1);
      } else if (searchTerm === "") {
        setCurrentPage(1);
        fetchUsers(1);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  // Handle search form submission
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      setCurrentPage(1);
      searchUsers(searchTerm, 1);
    }
  };

  const handleTypeChange = (event) => {
    console.log(event.target)
    setSelectedType(event.target.value);
  };

  // Fetch continents for React Select
  const fetchContinents = async () => {
    setContLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const contList = response.data?.data;
      const options = contList.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      const continentsWithAll = [
        { label: "All Continents", value: "all" },
        ...options
      ];

      setContinents(continentsWithAll);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching continents:", error);
        setContinents([{ label: "All Continents", value: "all" }]);
      }
    } finally {
      setContLoading(false);
    }
  };

  // Fetch regions based on selected continent
  const fetchRegions = async (continentId) => {
    setRegionLoading(true);
    try {
      let regionsData = [];

      if (continentId === 'all' || !continentId) {
        setRegions([{ label: "All Regions", value: "all" }]);
        return;
      }

      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      regionsData = response.data?.data?.regions || response.data?.data || [];
      const options = regionsData.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      const regionsWithAll = [
        { label: "All Regions", value: "all" },
        ...options
      ];

      setRegions(regionsWithAll);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([{ label: "All Regions", value: "all" }]);
    } finally {
      setRegionLoading(false);
    }
  };

  const fetchProvinces = async (regionId) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`,
        { headers }
      );
      console.log(response, "fullreponse");
      const provData = response?.data.data || [];
      const options = provData.map((item) => ({
        label: item.description || item.name,
        value: item.id,
      }));

      setProvinces(options);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setProvinces([]);
    } finally {
      setProvLoading(false);
    }
  };

  // Fetch regions for modal
  const fetchRegionsModal = async (continentId) => {
    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      const regionsData = response.data?.data?.regions || response.data?.data || [];
      const options = regionsData.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setRegionsModal(options);
    } catch (error) {
      console.error("Error fetching regions for modal:", error);
      setRegionsModal([]);
    }
  };

  const fetchProvincesModal = async (regionId) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`,
        { headers }
      );

      console.log("Provinces Modal Response:", response);
      const provData = response?.data?.data  || [];
      const options = provData.map((item) => ({
        label: item.description || item.name,
        value: item.id,
      }));

      setProvincesModal(options);
    } catch (error) {
      console.error("Error fetching provinces for modal:", error);
      setProvincesModal([]);
    } finally {
      setProvLoading(false);
    }
  };

  // Filter handlers
  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption);
    setSelectedRegion(null);
    setSelectedProvince(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchRegions(selectedOption.value);
    } else {
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  };

  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption);
    setSelectedProvince(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchProvinces(selectedOption.value);
    } else {
      setProvinces([]);
    }
  };

  const handleProvinceChange = (selectedOption) => {
    console.log("Selected Province:", selectedOption);
    setSelectedProvince(selectedOption);
  };

  // Modal filter handlers
  const handleContinentChangeModal = (selectedOption) => {
    setSelectedContinentModal(selectedOption);
    setSelectedRegionModal(null);
    setSelectedProvinceModal(null);
    setRegionsModal([]);
    setProvincesModal([]);
    if (selectedOption) {
      fetchRegionsModal(selectedOption.value);
    }
  };

  const handleRegionChangeModal = (selectedOption) => {
    console.log("Selected Region Modal:", selectedOption);
    setSelectedRegionModal(selectedOption);
    setSelectedProvinceModal(null);

    if (selectedOption && selectedOption.value !== 'all') {
      fetchProvincesModal(selectedOption.value);
    } else {
      setProvincesModal([]);
    }
  };

  const handleProvinceChangeModal = (selectedOption) => {
    console.log("Selected Province Modal:", selectedOption);
    setSelectedProvinceModal(selectedOption);
  };

  // Auto-fetch users when filters change
  useEffect(() => {
    if (bearer) {
      setCurrentPage(1);
      fetchUsers(1);
    }
  }, [selectedContinent, selectedRegion, selectedProvince, bearer]);

  // Fetch user types for dropdown
  const fetchData1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/all-usertype`, { headers });
      const typeList = response.data?.data;
      setUserType(typeList);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching user types:", error);
        setUserType([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchUsers(currentPage);
      fetchData1();
      fetchContinents();
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  }, [bearer]);



  const handleCloseCreateUserModal = () => {
    setShowCreateUserModal(false);
    resetNewUserForm();
  };



  // Skeleton loader
  const SkeletonLoader = () => {
    return (
      <>
        {Array.from({ length: 5 }).map((_, index) => (
          <tr key={index}>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '120px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.textby}><div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div></td>
            <td className={classes.btnAction}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
              </div>
            </td>
          </tr>
        ))}
      </>
    );
  };


  const [createLoading, setCreateLoading] = useState(false);

  const createUser = async () => {
    setCreateLoading(true);
    try {
      const selectedToggle = permissions
        .filter((item) => toggleStates[item.id])
        .map((item) => item.id);

      const selectedRoles = roles
        .filter((item) => roleStates[item.id])
        .map((item) => item.id);

      const payload = {
        name: fullName,
        email: email,
        phone_number: phone,
        type: selectedType,
        module: selectedToggle,
        permissions: selectedRoles,
        continent_id: selectedContinentModal?.value || '',
        region_id: selectedRegionModal?.value || '',
        province_id: selectedProvinceModal?.value || ''
      };

      console.log("Create User Payload:", payload);

      const response = await axios.post(
        `${BASE_URL}/users/create-new`,
        payload,
        { headers }
      );

      fetchUsers();
      handleCloseCreateUserModal();
      resetNewUserForm();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.log(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const toIdArray = (val, key = "id") => {
    if (!val) return [];
    if (Array.isArray(val)) return val.map(x => (typeof x === "object" ? x[key] : x));
    if (typeof val === "object" && Array.isArray(val[key])) return val[key];
    if (typeof val === "number" || typeof val === "string") return [Number(val)];
    return [];
  };

  const asToggleMap = (allIds, selectedIds) =>
    Object.fromEntries(allIds.map(id => [id, selectedIds.includes(id)]));

  const handleOpenEdit = async (user) => {
    setEditingUser(user);

    // Basic info
    setFullName(user.name || user.full_name || "");
    setEmail(user.email || "");
    setPhone(user.phone_number || user.phone || "");
    setSelectedType(String(user.user_type_id || user.type_id || user.type || ""));

    // Set React Select values for modal
    if (user.continent_id || user.continent?.id) {
      const continentOption = continents.find(c => c.value == user.continent_id || c.value == user.continent?.id);
      setSelectedContinentModal(continentOption);
      if (continentOption) {
        await fetchRegionsModal(continentOption.value);
      }
    }

    if (user.region_id || user.region?.id) {
      const regionOption = regionsModal.find(r => r.value == user.region_id || r.value == user.region?.id);
      setSelectedRegionModal(regionOption);
      if (regionOption) {
        await fetchProvincesModal(regionOption.value);
      }
    }

    if (user.province_id || user.province?.id) {
      const provinceOption = provincesModal.find(p => p.value == user.province_id || p.value == user.province?.id);
      setSelectedProvinceModal(provinceOption);
    }

    // Modules and Roles
    const userModuleIds = toIdArray(user.modules) || toIdArray(user.module_ids) || toIdArray(user.module) || [];
    const allModuleIds = permissions.map(p => p.id);
    const moduleMap = asToggleMap(allModuleIds, userModuleIds);
    setToggleStates(moduleMap);
    setCheckAll(allModuleIds.length > 0 && allModuleIds.every(id => moduleMap[id]));

    const userRoleIds = toIdArray(user.roles) || toIdArray(user.role_ids) || toIdArray(user.permissions) || [];
    const allRoleIds = roles.map(r => r.id);
    const roleMap = asToggleMap(allRoleIds, userRoleIds);
    setRoleStates(roleMap);
    setRoleCheckAll(allRoleIds.length > 0 && allRoleIds.every(id => roleMap[id]));

    setShow1(true);
  };
  // Update the reset function to include all fields
  const resetNewUserForm = () => {
    setFullName("");
    setFullName1("");
    setEmail("");
    setEmail1("");
    setPhone("");
    setPhone1("");
    setSelectedType("");
    setModalError("");
    setSelectedContinentModal(null);
    setSelectedRegionModal(null);
    setSelectedProvinceModal(null);
    setRegionsModal([]);
    setProvincesModal([]);
    setToggleStates({});
    setRoleStates({});
    setCheckAll(false);
    setRoleCheckAll(false);
  };

  // const fetchAllZones = async (provinceID) => {
  //   setProvLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/provinces/getzonesprovince?province_id=${provinceID}`,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: `Bearer ${TOKEN}`,
  //         },
  //       });

  //     // console.log(response);
  //     const subReg = response.data?.data;
  //     const options = subReg.map((item) => ({
  //       label: item.description,
  //       value: item.id,
  //     }));
  //     setZones(options);
  //     // console.log(subCont, "heeeer");
  //   } catch (error) {
  //     let errorMessage = 'An error occurred. Please try again.';
  //     if (error.response && error.response.data && error.response.data.message) {
  //       if (typeof error.response.data.message === 'string') {
  //         errorMessage = error.response.data.message;
  //       } else if (Array.isArray(error.response.data.message)) {
  //         errorMessage = error.response.data.message.join('; ');
  //       } else if (typeof error.response.data.message === 'object') {
  //         errorMessage = JSON.stringify(error.response.data.message);
  //       }
  //     }
  //     setZones([]);
  //   } finally {
  //     setProvLoading(false);
  //   }
  // };

  // const fetchAllAreas = async () => {
  //   setAreaLoad(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/zones/getareaszone?zone_id=${provinceID}`,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: `Bearer ${TOKEN}`,
  //         },
  //       // });
  //       });

  //     // console.log(response);
  //     const subReg1 = response.data?.data;
  //     const options1 = subReg1.map((item) => ({
  //       label: item.description,
  //       value: item.id,
  //     }));
  //     setAreas(options1);
  //     // console.log(subCont, "heeeer");
  //   } catch (error) {
  //     let errorMessage = 'An error occurred. Please try again.';
  //     if (error.response && error.response.data && error.response.data.message) {
  //       if (typeof error.response.data.message === 'string') {
  //         errorMessage = error.response.data.message;
  //       } else if (Array.isArray(error.response.data.message)) {
  //         errorMessage = error.response.data.message.join('; ');
  //       } else if (typeof error.response.data.message === 'object') {
  //         errorMessage = JSON.stringify(error.response.data.message);
  //       }
  //     }
  //     setAreas([]);
  //   } finally {
  //     setAreaLoad(false);
  //   }
  // };

  // useEffect(() => {
  //   if (TOKEN && provinceID) {
  //     fetchAllAreas(provinceID);
  //   }
  // }, [TOKEN, provinceID]);

  const fetchAllZones = async (provinceID) => {
    setProvLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/provinces/getzonesprovince?province_id=${provinceID}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const zoneList = response.data?.data || [];
      const formatted = zoneList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setZones(formatted);
  
      // 🚀 After zones load, fetch areas for the first zone
      if (formatted.length > 0) {
        fetchAllAreas(formatted[0].value);
      }
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
          setZones([]);
        } finally {
      setProvLoading(false);
    }
  };
  
  /* -----------------------------------------------------------
     FETCH ALL AREAS — NOTE: must accept `zoneID`
  ----------------------------------------------------------- */
  const fetchAllAreas = async (zoneID) => {
    setAreaLoad(true);
    try {
      const response = await axios.get(
        `${BASE_URL1}/zones/getareaszone?zone_id=${zoneID}`,
        {
          headers: {
            'Authorization': `Bearer ${TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      const areaList = response.data?.data || [];
      const formatted = areaList.map((item) => ({
        label: item.description,
        value: item.id,
      }));
  
      setAreas(formatted);
  
    } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
            if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
            } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
            } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
            }
          }
      setAreas([]);
    } finally {
      setAreaLoad(false);
    }
  };
  

  useEffect(() => {
    if (bearer && provinceID) {
      fetchAllZones(provinceID);
    }
  }, [TOKEN, provinceID]);

  const handleProcess = async () => {
    setProcessLoading(true);

    try {
      const response = await axios.get(`${BASE_URL1}/parishes/fetch-by-type?continent_id=${continentID}&region_id=${regionID}&province_id=${provinceID}&page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        // params: {
        //   zone_id: zones.id || '',
        //   area_id: selectedArea || ''
        // }
      });

       const results = response.data?.data?.parishes?.data;
      setTableData(results);
      const resultx = response.data?.data?.parishes?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.parishes?.last_page || 1;
      setTotalPages(total);

      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      // Swal.fire({
      //   icon: 'error',
      //   title: 'Failed',
      //   text: errorMessage,
      // });
    } finally {
      setProcessLoading(false);
    }
  };

  useEffect(() => {
    if (TOKEN, continentID, regionID, provinceID) {
      handleProcess();
    }
  }, [TOKEN, continentID, regionID, provinceID]);

  const fetchAll = async () => {
    setProcessLoading1(true);
    try {
      const response = await axios.get(`${BASE_URL1}/parishes/fetch-by-param?continent_name=${continentName}&region_name=${regionName}&province_name=${provinceName}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        // params: {
        //   zone_id: zones.id || '',
        //   area_id: selectedArea || ''
        // }
      });

      const results = response.data?.data.data || [];

      // const formatted = results.map((item) => ({
      //   id: item.id,
      //   description: item.description,
      //   created_at: item.created_at,
      //   updated_at: item.updated_at,
      //   continent: item?.continent?.description || "",
      //   province: item?.province?.description || "",
      //   region: item?.region?.description || "",
      // }));
  
      setTableData1(results);
      setTotalEntries(results.length);
      setTotalPages(1);
      // setTotalEntries(formatted.length); // For display text if needed
      setTotalPages(1);
      // const resultx = response.data?.data?.parishes?.total;
      // setTotalEntries(resultx);
      // const total = response.data?.data?.parishes?.last_page || 1;
      // setTotalPages(total);

      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      // Swal.fire({
      //   icon: 'error',
      //   title: 'Failed',
      //   text: errorMessage,
      // });
    } finally {
      setProcessLoading1(false);
    }
  };

      // UPDATED: UseEffect for default fetchAll (only when fetchMode is 'default')
      useEffect(() => {
        if (TOKEN && continentName && regionName && provinceName && fetchMode === 'default') {
          fetchAll();
        }
      }, [TOKEN, continentName, regionName, provinceName]);
      // REMOVED: useEffect for handleProcess (no longer auto-called)
      // NEW: useEffect to refetch when currentPage changes in 'area' mode
      useEffect(() => {
        if (fetchMode === 'area') {
          handleAreaProcess();
        }
      }, [fetchMode]);


   const handleAreaProcess = async () => {
    setLoading(true);
  

    try {
      const response = await axios.get(`${BASE_URL1}/parishes/get-all?page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${TOKEN}`
        },
        params: {
          zone_id: selectedZone || '',
          area_id: selectedArea || ''
        }
      });

      const results = response.data?.data?.data;
      setTableData(results);
      const resultx = response.data?.data?.data?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.data?.last_page || 1;
      setTotalPages(total);

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };


  const handleArea = (selectedOption) => {
    setSelectedArea(selectedOption.value);
    if (!selectedOption.value) {
      setFetchMode('default');
      fetchAll();
    }
  };



  // FIXED: Use permissions state instead of undefined variable
  useEffect(() => {
    if (!editingUser || !permissions.length) return;
    const userModuleIds = toIdArray(editingUser.modules) || toIdArray(editingUser.module_ids) || toIdArray(editingUser.module) || [];
    const allModuleIds = permissions.map(p => p.id);
    const moduleMap = asToggleMap(allModuleIds, userModuleIds);
    setToggleStates(moduleMap);
    setCheckAll(allModuleIds.length > 0 && allModuleIds.every(id => moduleMap[id]));
  }, [permissions, editingUser]);

  useEffect(() => {
    if (!editingUser || !roles.length) return;
    const userRoleIds = toIdArray(editingUser.roles) || toIdArray(editingUser.role_ids) || toIdArray(editingUser.permissions) || [];
    const allRoleIds = roles.map(r => r.id);
    const roleMap = asToggleMap(allRoleIds, userRoleIds);
    setRoleStates(roleMap);
    setRoleCheckAll(allRoleIds.length > 0 && allRoleIds.every(id => roleMap[id]));
  }, [roles, editingUser]);

  const updateUser = async (user) => {
    setCreateLoading(true);
    try {
      const selectedToggle = permissions
        .filter((item) => toggleStates[item.id])
        .map((item) => item.id);

      const selectedRoles = roles
        .filter((item) => roleStates[item.id])
        .map((item) => item.id);

      const response = await axios.post(
        `${BASE_URL}/users/update-user`,
        {
          name: fullName,
          email: email,
          phone_number: phone,
          type: selectedType,
          module: selectedToggle,
          permissions: selectedRoles,
          continent_id: selectedContinentModal?.value,
          region_id: selectedRegionModal?.value,
          province_id: selectedProvinceModal?.value,
          user_id: editingUser.id
        },
        { headers }
      );

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });

      handleClose1();
      resetNewUserForm();
      fetchUsers();

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.log(error);
    } finally {
      setCreateLoading(false);
    }
  };

  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handleViewFixed = async () => {
    setSelectedItemId(parishID);
    setViewLoading(true);
    console.log(parishID);
    try {
      const response = await axios.get(
        `${BASE_URL1}/fixedassets/get-by-type?parish_id=${parishID}`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`,
          },
        }
      );

      const instructionData1 = response.data?.data?.assets?.data;
      setTableData(instructionData1);
      const resultx = response.data?.data?.assets?.total;
      setTotalEntries(resultx);
      const total = response.data?.data?.assets?.last_page || 1;
      setTotalPages(total);
      console.log(instructionData1, "Am here");
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
    } finally {
      setViewLoading(false);
    }
  };

  useEffect(() => {
    if (TOKEN) {
      handleViewFixed();
    }
  }, [TOKEN, currentPage]);

  const handleEyeClick = (id) => {
    const foundAsset = tableData.find((item) => item.id === id);
    navigate("/view_asset", { state: { selectedAsset: foundAsset } });
    setEyeClicked(true);
  };

  // const datatoRender = useMemo(() => {
  //   return fetchMode === 'area' ? tableData : tableData1;
  // }, [fetchMode, tableData, tableData1]);

  const exportToPDF = async () => {
    if (!tableData || tableData.length === 0) {
      alert("No asset data available to export.");
      return;
    }
  
    setIsPdfLoading(true);
  
    try {
      const doc = new jsPDF({ orientation: "landscape" });
      doc.setFontSize(14);
      doc.text("Assets Report", 14, 15);
  
      const tableColumn = [
        "S/N",
        "Identification Number",
        "Description",
        "Asset Category",
        "Quantity",
        "Amount Purchased",
        "Approval Status",
      ];
  
      const tableRows = tableData.map((item, index) => [
        index + 1,
        item.identification_number,
        item.description,
        item.asset_category?.description || "",
        item.quantity,
        item.amount_purchased,
        item.approval_status === "0"
          ? "Pending Approval"
          : item.approval_status === "1"
          ? "Checker Approved"
          : item.approval_status === "2"
          ? "Accountant Approved"
          : item.approval_status === "3"
          ? "Disapproved"
          : "",
      ]);
  
      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 25,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [40, 167, 69] },
      });
  
      doc.save(
        `Assets_${new Date().toISOString().split("T")[0]}.pdf`
      );
    } finally {
      setIsPdfLoading(false);
    }
  };
  

  const exportToExcel = async () => {
    if (!tableData || tableData.length === 0) {
      alert("No asset data available to export.");
      return;
    }
  
    setIsExcelLoading(true);
  
    try {
      const formatted = tableData.map((item, index) => ({
        "S/N": index + 1,
        "Identification Number": item.identification_number,
        "Description": item.description,
        "Asset Category": item.asset_category?.description || "",
        "Quantity": item.quantity,
        "Amount Purchased": item.amount_purchased,
        "Approval Status":
          item.approval_status === "0"
            ? "Pending Approval"
            : item.approval_status === "1"
            ? "Checker Approved"
            : item.approval_status === "2"
            ? "Accountant Approved"
            : item.approval_status === "3"
            ? "Disapproved"
            : "",
      }));
  
      const ws = XLSX.utils.json_to_sheet(formatted);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Assets");
  
      XLSX.writeFile(
        wb,
        `Assets_${new Date().toISOString().split("T")[0]}.xlsx`
      );
    } finally {
      setIsExcelLoading(false);
    }
  };
  
  
  

  return (
    <div>
      <HeaderNav />

      {/* Create User Modal */}
      <Modal show={showCreateUserModal} onHide={handleCloseCreateUserModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create New User & Assign Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          {modalError && <Alert variant="danger">{modalError}</Alert>}

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}>User Information</h5>
            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Type</Form.Label>
                <Form.Select
                  className="form-control"
                  as="select"
                  value={selectedType}
                  onChange={handleTypeChange}
                >
                  <option value="" disabled>Select Type</option>
                  {userType.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.type}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* For Continent */}
              {selectedType === '2' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>

              )}

              {/* For Region */}
              {selectedType === '3' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}

              {/* For Province */}
              {selectedType === '4' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}
            </div>
          </div>

          {/* Rest of your modal content (permissions, roles, etc.) */}
          <hr className={classes.divider} />

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                {/* <ToggleSlider checked={checkAll} onChange={handleCheckAllToggle} /> */}
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>User Modules</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {permLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  permissions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      {/* <ToggleSlider
                        checked={toggleStates[item.id]}
                        onChange={() => handleToggleChange(item.id)}
                      /> */}
                    </div>
                  ))
                )}
              </div>
            </>
          )}

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                {/* <ToggleSlider checked={roleCheckAll} onChange={handleCheckAllRoles} /> */}
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>Roles & Permissions</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {roleLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  roles.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      {/* <ToggleSlider
                        checked={roleStates[item.id]}
                        onChange={() => handleRoleToggleChange(item.id)}
                      /> */}
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCreateUserModal}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            onClick={createUser}
            variant="primary"
          >
            {createLoading ? <><Spinner size="sm" /> Creating...</> : "Save User & Permissions"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit User Modal */}
      <Modal show={show1} onHide={handleClose1} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update User & Permissions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '30px' }}>
          {modalError && <Alert variant="danger">{modalError}</Alert>}

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}>User Information</h5>
            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Full Name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className={classes.formGroup}>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className={classes.formRow}>
              <Form.Group className={classes.formGroup}>
                <Form.Label>Type</Form.Label>
                <Form.Select
                  className="form-control"
                  as="select"
                  value={selectedType}
                  onChange={handleTypeChange}
                >
                  <option value="" disabled>Select Type</option>
                  {userType.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.type}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* For Continent */}
              {selectedType === '2' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}

              {/* For Region */}
              {selectedType === '3' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}

              {/* For Province */}
              {selectedType === '4' && (
                <>
                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Continent</Form.Label>
                    <Select
                      onChange={handleContinentChangeModal}
                      options={continents}
                      value={selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Region</Form.Label>
                    <Select
                      onChange={handleRegionChangeModal}
                      options={regionsModal}
                      value={selectedRegionModal}
                      isDisabled={!selectedContinentModal}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>

                  <Form.Group className={classes.formGroup}>
                    <Form.Label>Select Province</Form.Label>
                    <Select
                      onChange={handleProvinceChangeModal}
                      options={provincesModal}
                      value={selectedProvinceModal}
                      isDisabled={!selectedRegionModal || selectedRegionModal?.value === 'all'}
                      isLoading={provLoading}
                      menuPortalTarget={document.body}
                      styles={selectStyles}
                    />
                  </Form.Group>
                </>
              )}
            </div>
          </div>

          {/* Rest of edit modal content */}
          <hr className={classes.divider} />

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                {/* <ToggleSlider checked={checkAll} onChange={handleCheckAllToggle} /> */}
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>User Modules</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {permLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  permissions.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      {/* <ToggleSlider
                        checked={toggleStates[item.id]}
                        onChange={() => handleToggleChange(item.id)}
                      /> */}
                    </div>
                  ))
                )}
              </div>
            </>
          )}

          {!(selectedType === '1' || selectedType === '7' || selectedType === '8') && selectedType && (
            <>
              <div className='modal-footer' style={{ marginTop: 40 }} />
              <div style={{ display: "flex", gap: 5 }}>
                {/* <ToggleSlider checked={roleCheckAll} onChange={handleCheckAllRoles} /> */}
                <p>Check All</p>
              </div>
              <h1 style={{ fontSize: 20, marginTop: 20 }}>Roles & Permissions</h1>
              <div className='modal-footer' style={{ marginTop: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: "center", justifyContent: "center" }}>
                {roleLoading ? (
                  <Spinner size='sm' animation="border" role="status" />
                ) : (
                  roles.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        width: '130px',
                        height: '130px',
                        margin: '5px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid rgba(0, 0, 0, 0.2)',
                        boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
                        boxSizing: 'border-box',
                        marginBottom: 20,
                        overflow: 'hidden'
                      }}
                    >
                      <p style={{ fontSize: 13.5, margin: '5px 0', textAlign: "center", whiteSpace: "normal", wordWrap: "break-word", overflowWrap: "break-word", maxWidth: "100%" }}>{item.name}</p>
                      {/* <ToggleSlider
                        checked={roleStates[item.id]}
                        onChange={() => handleRoleToggleChange(item.id)}
                      /> */}
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>Cancel</Button>
          <Button
            className={classes.createUserButton}
            onClick={updateUser}
            variant="primary"
          >
            {createLoading ? <><Spinner size="sm" /> Updating...</> : "Update User & Permissions"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Main Content */}
      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button  onClick={(e) => { e.preventDefault();
            navigate('/fixed_asset_home');}}  className={classes.buttonsNav}>Dashboard</Button>
          <Button  onClick={(e) => {
    e.preventDefault();
    navigate('/fixed_asset/provincial_user');
  }} className={classes.buttonsNav}>Manage Users</Button>
          <Button  onClick={(e) => {
    e.preventDefault();
    navigate('/fixed_asset/zone');
  }} className={classes.buttonsNav}>Manage Zones</Button>
          <Button  onClick={(e) => {
    e.preventDefault();
    navigate('/fixed_asset/area');
  }} className={classes.buttonsNav}>Manage Areas</Button>
          <Button  onClick={(e) => {
    e.preventDefault();
    navigate('/fixed_asset/parish');
  }} className={classes.buttonsNav}>Manage Parish</Button>
          <Button  onClick={(e) => {
    e.preventDefault();
    navigate('/fixed/asset/report');
  }} className={classes.buttonsNav}>Report</Button>
        </div>

        <div style={{ marginTop: 24 }} />
        {/* <h3 className={classes.topText}>Manage Parish</h3>
        <p className={classes.prgText}>View All Parish.</p> */}
        <div className={classes.butnlays}>
        <div className={classes.dwnbtn}>
        <button
  className={classes.downBtn}
  onClick={exportToExcel}
  disabled={isExcelLoading}
>
  {isExcelLoading ? (
    <>
      <Spinner
        animation="border"
        size="sm"
        className="me-2"
      />
      Downloading Excel...
    </>
  ) : (
    <>
      <FileSpreadsheet size={20} style={{ marginRight: 6 }} />
      Download Excel
    </>
  )}
</button>

<button
  className={classes.downBtn}
  onClick={exportToPDF}
  disabled={isPdfLoading}
>
  {isPdfLoading ? (
    <>
      <Spinner
        animation="border"
        size="sm"
        className="me-2"
      />
      Downloading PDF...
    </>
  ) : (
    <>
      <FileText size={20} style={{ marginRight: 6 }} />
      Download PDF
    </>
  )}
</button>

            </div>
            
            <div className={classes.inputWrapper}>
              {/* <img src={searchicon} alt="Search" className={classes.inputIconGreen} /> */}
              <input type="text" className={classes.searchBar} 
               value={searchTerm}
               onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search Assest" />
            </div>
        </div>

        <div className={classes.subContainer} style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'nowrap', justifyContent: 'space-between', marginBottom: '-17px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1, marginTop: '-17px' }}>
            {/* Continent Filter */}
            {/* <div style={{ minWidth: '200px' }}>
              <Form.Label className={classes.filterLabel}>Area</Form.Label>
              <Select
                  onChange={(selectedOption) => handleArea(selectedOption)}
                  options={areas}
                placeholder="Select Area"
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}

            {/* <Button
                                style={{ borderRadius: 5, marginLeft: "10px", marginTop: "26px", background: "#092147",  }} onClick={() => {
                                  setFetchMode('area');
                                
                                  handleAreaProcess();
                                }} >
                                {loading ? (
                                  <>
                                    <Spinner size='sm' />
                                    <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                                  </>
                                ) : (
                                  "Process"
                                )}
                              </Button> */}

            {/* Region Filter */}
            {/* <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Region</Form.Label>
              <Select
                onChange={handleRegionChange}
                options={regions}
                value={selectedRegion}
                isDisabled={!selectedContinent || selectedContinent?.value === 'all'}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}

            {/* <div style={{ minWidth: '150px' }}>
              <Form.Label className={classes.filterLabel}>Province</Form.Label>
              <Select
                onChange={handleProvinceChange}
                options={provinces}
                value={selectedProvince}
                isDisabled={!selectedRegion || selectedRegion?.value === 'all'}
                isLoading={provLoading}
                menuPortalTarget={document.body}
                styles={selectStyles}
              />
            </div> */}
          </div>

          {/* <div className={classes.statCount} style={{ flexShrink: 0, margin: '0 auto', marginRight: '5%' }}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>Users</p>
              {loading ? (
                <div className={classes.skeleton} style={{ width: '40px', height: '24px', marginTop: '-10px' }}></div>
              ) : (
                <p className={classes.txtHds}>{users.length}</p>
              )}
            </div>
          </div> */}

          {/* <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexShrink: 0 }}> */}

            {/* <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search users..."
              />
              <Search className={classes.searchIcon} size={16} />
              {searchLoading && (
                <div className={classes.searchSpinner}>
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{
                      width: '16px',
                      height: '16px'
                    }}
                  />
                </div>
              )}
            </div> */}

            {/* Print View Button */}
            {/* <div>
              <button className={classes.loanBtn} onClick={handlePrintView}>
                <MdPrint size={18} style={{ marginRight: '2px' }} />
                Print
              </button>
            </div> */}

            {/* Add New User Button */}
            {/* <div>
              <button className={classes.loanBtn} onClick={handleShowCreateUserModal}>
                <img src={plus} alt="plus" />New User
              </button>
            </div>
          </div> */}
        </div>

        {/* <div style={{ marginTop: 24 }} /> */}

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>#</th>
                <th>Identification Number</th>
                                            <th>Asset Name</th>
                                            <th>Category</th>
                                            <th>Quantity</th>
                                            <th>Amount</th>
                                            <th>Approval Status</th>
                                            <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading || processLoading ? (
                <SkeletonLoader />
              ) : tableData.length > 0 ? (
                tableData.map((item, index) => (
                  <tr key={index}>
                                              <td className={classes.textby}  >{index + 1}</td>
                                              <td className={classes.textby} style={{paddingLeft: 20}} >
                                                {item.identification_number}
                                              </td>
                                              <td className={classes.textby} style={{paddingLeft: 15}}>{item.description}</td>
                                              <td
                                              className={classes.textby}
                                                style={{ whiteSpace: "wrap" }}
                                              >
                                                {
                                                  item.asset_category
                                                    ?.description
                                                }
                                              </td>
                                              <td className={classes.textby} style={{paddingLeft: 30}}>{item.quantity}</td>
                                              <td className={classes.textby} >{item.amount_purchased}</td>
                                              <td className={classes.textby} >
                                                <Badge
                                                  style={{ padding: 10 }}
                                                  bg={
                                                    item.approval_status === "0"
                                                      ? "warning"
                                                      : item.approval_status ===
                                                        "1"
                                                      ? "success"
                                                      : item.approval_status ===
                                                        "2"
                                                      ? "success"
                                                      : item.approval_status ===
                                                        "3"
                                                      ? "danger"
                                                      : ""
                                                  }
                                                >
                                                  {item.approval_status === "0"
                                                    ? "Pending Approval"
                                                    : item.approval_status ===
                                                      "1"
                                                    ? "Checker Approved"
                                                    : item.approval_status ===
                                                      "2"
                                                    ? "Accountant Approved"
                                                    : item.approval_status ===
                                                      "3"
                                                    ? "Disapproved"
                                                    : ""}
                                                </Badge>
                                              </td>
                                              <td
                                                style={{ whiteSpace: "nowrap", paddingLeft: 20 }}
                                              >
                                                <div
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    handleEyeClick(item.id)
                                                  }}
                                                  className="btn btn-success-soft btn-sm mr-1"
                                                >
                                                <Pencil
                                                    size={14}
                                                    color="#008a4b"
                                                    style={{
                                                      color: "#008a4b",
                                                      backgroundColor:
                                                        "#28a7451a",
                                                      padding: 2,
                                                      borderColor: "#28a7454d",
                                                      borderRadius: 5,
                                                      fontSize: 12,
                                                    }}
                                                  />
                                                </div>
                                                {/* <div className="btn btn-danger-soft btn-sm" style={{ marginLeft: 5 }} onClick={() => handleShow2(item.id)}>
                                            <label htmlFor="fileInput" style={{ cursor: 'pointer', color: "#008a4b", backgroundColor: "#28a7451a", padding: 2, borderColor: "#28a7454d", borderRadius: 5, fontSize: 12 }} >
                                             Transfer Asset

                                            </label>
                                          </div> */}
                                              </td>
                                            </tr>
                ))
              ) : (
                <tr style={{fontSize: "12px"}}>
                  <td colSpan="7" className="text-center p-4" style={{ color: '#6c757d' }}>
                    {searchTerm ? `No asset found matching "${searchTerm}"` : "No asset available."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className={classes.paginationStyle}>
          <div className={classes.footerSubOne}>
            <button
              className={classes.btnFirst}
              onClick={handleFirstPage}
              disabled={currentPage === 1}
            >
              First
            </button>
            <span className={classes.ftOne}>
              {getPageNumbers().map(pageNum => (
                <button
                  key={pageNum}
                  className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                  onClick={() => handlePageClick(pageNum)}
                >
                  {pageNum}
                </button>
              ))}
            </span>
            <button
              className={classes.btnSec}
              onClick={handleLastPage}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
          <p className={classes.displayPag}>
            Displaying {(currentPage - 1) * perPage + 1}-{Math.min(currentPage * perPage, totalUsers)} of {totalUsers} users
          </p>
        </div>
      </div>
    </div>
  )
}

export default ViewFixedAsset;